export const GENDERS = {
  MALE: 'Male',
  FEMALE: 'Female',
};
